import { useEffect } from "react";
import "./app.css";
import "./custom.css";

export default () => {
    const data = [
        {
            id: "d8a0e19f-dfb3-4e69-bb99-a2533fd09627",
            name: "Botany",
            address: "500 Ti Rakau Drive, Botany Downs, Auckland",
            available: true,
        },
        {
            id: "342091b7-7b23-40f7-b380-a86bea2a2c90",
            name: "Christchurch",
            address: "88 Hereford Street, Christchurch Central City, Christchurch 8011",
            available: true,
        },
        {
            id: "bde22d98-58ee-4153-b8be-ebdbf0bae807",
            name: "Customs St, Auckland CBD",
            address: "22 Customs Street East, Auckland CBD, Auckland 1010",
            available: true,
        },
        {
            id: "d22ecc1b-dc1e-4041-a526-98df6146777a",
            name: "Lynn Mall",
            address: "3058 Great North Road, New Lynn, Auckland 0600",
            available: true,
        },
        {
            id: "a8299d94-2aba-4e74-b9b1-f5a753f6ca79",
            name: "Mānawa Bay",
            address: "4 Jimmy Ward Crescent, Auckland Airport, Auckland 2022",
            available: true,
        },
        {
            id: "f479b649-0fde-48d5-9be9-41ea289d936d",
            name: "Manukau",
            address: "Manukau Supa Centa Cavendish Drive, Manukau City Centre, Auckland 2104",
            available: true,
        },
        {
            id: "53a2c8fe-d620-48a4-ac6b-69854424180d",
            name: "Ormiston",
            address: "William Ralph Road, Ormiston, Auckland",
            available: true,
        },
        {
            id: "bc6623fa-8e45-4088-9bf4-4b7679b416e7",
            name: "Ponsonby",
            address: "45 Ponsonby Road, Ponsonby, Auckland",
            available: true,
        },
        {
            id: "cc7884b6-cacf-4fdb-9211-9a1f9c5a5fb6",
            name: "Sylvia Park",
            address: "286 Mount Wellington Highway, Auckland",
            available: true,
        },
        {
            id: "d935d8e4-f30f-466b-8147-7c60a5e838ad",
            name: "Tauranga",
            address: "Shop RR203, 2 Taurikura Drive, Tauriko, Tauranga",
            available: true,
        },
        {
            id: "0aec9c5c-b2a7-4803-8b01-69ee93bc8bf9",
            name: "Whangaparaoa",
            address: "6 Main Street, Stanmore Bay, Whangaparāoa 0932",
            available: true,
        },
    ];

    const onOrder = (link) => {
        window.location.href = `https://order.tabin.co.nz/restaurant/${link}`;
    };

    return (
        <>
            <div className="restaurant-list">
                <img
                    src={`https://d1hfsnuz4i23pd.cloudfront.net/public/2024-08-11_00:25:08.152-Better-Burger.png`}
                    className="restaurant-list-logo"
                    alt="logo"
                />
                <div className="select-location">Please select a location</div>
                {data &&
                    data.map((restaurant, index) => (
                        <div key={restaurant.id}>
                            {index != 0 && <div className="separator-4"></div>}
                            <div className="restaurant-list-item">
                                <div>
                                    <div className="restaurant-name mb-2">{restaurant.name}</div>
                                    <div className="restaurant-description">{restaurant.address}</div>
                                </div>
                                <button
                                    className={`button ${restaurant.available ? "" : "disabled"}`}
                                    onClick={() => {
                                        restaurant.available && onOrder(restaurant.id);
                                    }}
                                >
                                    {restaurant.available ? "Order Here" : "Unavailable"}
                                </button>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};
